// extracted by mini-css-extract-plugin
export default {"indexContainer":"SpacingContainer_indexContainer__Kakk1"};